module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/theme/packages/core-app/src/templates/formErrorListItemView.html -->\n'+
((__t=( name ))==null?'':__t)+
'';
}
return __p;
};
